// ---------------------------------------------------------------
// useSchedule.js — Horario mensual de un usuario, en tiempo real.
// ---------------------------------------------------------------
import { useEffect, useState } from "react";
import { subscribeSchedule } from "../services/scheduleService";

export function useSchedule(uid, key) {
  const [schedule, setSchedule] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!uid || !key) return undefined;
    setLoading(true);
    const unsubscribe = subscribeSchedule(
      uid,
      key,
      (data) => {
        setSchedule(data);
        setLoading(false);
      },
      (error) => {
        console.error("Error leyendo horario:", error);
        setSchedule(null);
        setLoading(false);
      }
    );
    return unsubscribe;
  }, [uid, key]);

  return { schedule, loading };
}
